import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Navbar from "./Navbar";
import DrawerContent from "./DrawerContent";

const DrawerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

export default function MiniDrawer({
  children,
  menuList,
  isStaticRoute = false,
}) {
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(true);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDrawerOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleDrawerMobileOpen = () => {
    setMobileOpen(true);
  };

  const handleDrawerMobileClose = () => {
    setMobileOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Navbar
        open={open}
        mobileOpen={mobileOpen}
        onDrawerToggle={handleDrawerOpen}
        onMobileDrawerOpen={handleDrawerMobileOpen}
      />

      <DrawerContent
        open={open}
        mobileOpen={mobileOpen}
        screenWidth={screenWidth}
        menuList={menuList}
        isStaticRoute={isStaticRoute}
        onMobileDrawerOpen={handleDrawerMobileOpen}
        onMobileDrawerClose={handleDrawerMobileClose}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          height: "100% !important",
          overflowX: "hidden",
        }}
      >
        <DrawerHeader />
        {children}
      </Box>
    </Box>
  );
}
